// extracted by mini-css-extract-plugin
export var author = "ComponentReviewsSpotlightItem-module--author--fecb1";
export var content = "ComponentReviewsSpotlightItem-module--content--d4331";
export var contentWrapper = "ComponentReviewsSpotlightItem-module--contentWrapper--92eff";
export var image = "ComponentReviewsSpotlightItem-module--image--02c55";
export var initials = "ComponentReviewsSpotlightItem-module--initials--e1d49";
export var label = "ComponentReviewsSpotlightItem-module--label--3a3de";
export var occupation = "ComponentReviewsSpotlightItem-module--occupation--ec251";
export var slide = "ComponentReviewsSpotlightItem-module--slide--1ac19";